import { Link } from "@mui/material";
import { spaNavigate } from "../routeLink";

type WorkflowRunsEmptyStateProps = {
  /** Sentence before the link, e.g. "No runs yet. Start one from the". */
  message: string;
  /** Where the start-one link points (the product's kickoff page). */
  linkHref: string;
  linkLabel: string;
  /** SPA navigation to linkHref (usually history.push). */
  onNavigate: () => void;
};

/**
 * The shared "nothing here yet, start one over there" empty state for
 * workflow runs pages, so the three products render one implementation.
 * A real href so middle-click and open-in-new-tab work, with a click
 * handler for SPA navigation. MUI's component={RouterLink} does not
 * typecheck here: the nested @types/react under @types/react-router makes
 * its ReactNode incompatible with the app's.
 */
const WorkflowRunsEmptyState = ({
  message,
  linkHref,
  linkLabel,
  onNavigate,
}: WorkflowRunsEmptyStateProps) => (
  <>
    {message}{" "}
    <Link
      href={linkHref}
      onClick={spaNavigate(onNavigate)}
      data-testid="workflow-runs-empty-link"
    >
      {linkLabel}
    </Link>
  </>
);

export default WorkflowRunsEmptyState;
